import { createTheme } from '@mui/material/styles';
import typography from './Typography';
import overrides from './overrides';
import palette from './palette';
export default createTheme({
    typography: typography,
    components: overrides,
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
    palette: palette
});
